import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ActionMenu } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Stack, Tooltip, Typography } from '@lyearn/ui';
import { DifficultyEnum } from '@/types/schema';

import { QUESTION_DIFFICULTY_CONFIG } from './config';
import { DifficultyLevelProps } from './types';
import { getMenuItems } from './utils';

const DifficultyLevel: React.FC<DifficultyLevelProps> = (props) => {
  const { difficulty, onChange, allowPartialUpdates } = props;
  const { t } = useTranslation();

  const menuItems = getMenuItems(t, difficulty);

  const currentConfig = QUESTION_DIFFICULTY_CONFIG[difficulty];

  const onAction = useCallback(
    (actionType: string) => {
      onChange(actionType as DifficultyEnum);
    },
    [onChange],
  );

  return (
    <Stack alignItems="center" className="-my-10 ps-8" justifyContent="between">
      <Typography variant="body-short-02">
        {t('QuizCreator:QuestionsSettings.Difficulty')}
      </Typography>
      <ActionMenu disabled={allowPartialUpdates} items={menuItems} onAction={onAction}>
        <Tooltip
          disableHoverListener={!allowPartialUpdates}
          placement="left"
          title={t('QuizCreator:QuestionsSettings.DifficultyRestrictedTooltip')!}>
          <Stack
            className={cn(
              'cursor rounded-4 px-8 py-4',
              allowPartialUpdates ? 'cursor-default opacity-50' : 'hover:bg-interactive-secondary',
            )}
            gapX={8}>
            {<currentConfig.Icon className="h-20 w-20" />}
            <Typography variant="body-short-02">{t(currentConfig.labelKey)}</Typography>
          </Stack>
        </Tooltip>
      </ActionMenu>
    </Stack>
  );
};

export default DifficultyLevel;
